import classNames from 'classnames';
import React from 'react';
import { isEven } from '../../../utils/isEven.util';

interface StoryblokTableProps {
  tableData: StoryblokTableData;
  pre_headers: string[];
  header_bg_colour: string;
  header_text_colour: string;
  even_row_bg_colour: string;
  odd_row_bg_colour: string;
  pre_header_text_colour: string;
  odd_row_text_colour: string;
  even_row_text_colour: string;
  pre_header_bg_colour: string;
}

export interface StoryblokTableData {
  thead: { value: string }[];
  tbody: { body: { value: string }[] }[];
}

interface TableHeadersProps {
  headers: { value: string }[];
  textColor: string;
}

interface TableRowProps {
  row: { value: string }[];
  odd_row_text_colour: string;
  even_row_text_colour: string;
  idx: number;
}

export const TableHeaders: React.FC<TableHeadersProps> = ({ headers, textColor }) => {
  return (
    <>
      {headers.map((header, idx) => (
        <th key={`th-${idx}`} className="font-bold py-4 px-2" style={{ color: textColor }}>
          {header.value}
        </th>
      ))}
    </>
  );
};

export const TableRow: React.FC<TableRowProps> = ({ row, odd_row_text_colour, even_row_text_colour, idx }) => {
  return (
    <>
      {row.map(cell => (
        <td
          key={`td-${idx}`}
          style={{ color: isEven(idx) ? even_row_text_colour : odd_row_text_colour }}
          className="font-bold text-sm py-4 px-2"
        >
          {cell.value}
        </td>
      ))}
    </>
  );
};

const StoryblokTable: React.FC<StoryblokTableProps> = ({
  tableData,
  pre_headers,
  header_bg_colour,
  even_row_bg_colour,
  odd_row_bg_colour,
  pre_header_bg_colour,

  header_text_colour,
  pre_header_text_colour,
  odd_row_text_colour,
  even_row_text_colour,
}) => {
  return (
    <div>
      <div className="flex justify-center items-center w-full space-x-6">
        {pre_headers.map(header => (
          <div
            className={classNames('w-full rounded-t-[20px] py-4 text-[white] text-center')}
            style={{ backgroundColor: pre_header_bg_colour }}
          >
            <p style={{ color: pre_header_text_colour }}>{header}</p>
          </div>
        ))}
      </div>
      <table className="w-full table-fixed">
        <thead>
          <tr style={{ backgroundColor: header_bg_colour }}>
            <TableHeaders headers={tableData.thead} textColor={header_text_colour} />
          </tr>
        </thead>
        <tbody>
          {tableData.tbody.map((row, idx) => (
            <tr
              key={`row-${idx}`}
              style={{ backgroundColor: isEven(idx) ? even_row_bg_colour : odd_row_bg_colour }}
              className="text-base text-center leading-6"
            >
              <TableRow
                row={row.body}
                odd_row_text_colour={odd_row_text_colour}
                even_row_text_colour={even_row_text_colour}
                idx={idx}
              />
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StoryblokTable;
